"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSpotShiftStore = createSpotShiftStore;
const vue_1 = require("vue");
const api = __importStar(require("../api"));
function createSpotShiftStore() {
    const state = (0, vue_1.reactive)({
        shifts: {},
        params: {},
        pagination: {
            cursor: "",
            done: false,
        },
        fetching: false,
        mutating: false,
    });
    async function fetchNextPage() {
        if (state.fetching || state.pagination.done) {
            return;
        }
        try {
            state.fetching = true;
            const res = await api.getSpotShifts(state.params, state.pagination.cursor);
            res.data.shifts.forEach((shift) => {
                state.shifts[shift.id] = shift;
            });
            state.pagination.cursor = res.pagination.cursor;
            state.pagination.done = res.pagination.done;
        }
        catch (err) {
            throw new Error(`Failed to get shifts. Error: ${err}`);
        }
        finally {
            state.fetching = false;
        }
    }
    async function refresh() {
        if (state.fetching) {
            return;
        }
        resetPagination();
        state.shifts = {};
        await fetchNextPage();
    }
    function setParams(params) {
        state.params = {
            ...params,
        };
        resetPagination();
        state.shifts = {};
    }
    async function createShift(payload) {
        if (state.mutating) {
            return;
        }
        try {
            state.mutating = true;
            const res = await api.createSpotShift(payload);
            res.slotIds.forEach((sId) => {
                const spotShift = {
                    spotWorker: 0,
                    id: sId,
                    start: payload.start,
                    end: payload.end,
                    industry: payload.industry,
                    purpose: payload.purpose,
                    userId: 0,
                    branchId: payload.branchId,
                    branchName: "",
                    contact: payload.contact,
                    groupId: 0,
                    access: payload.access,
                    details: payload.details,
                    wage: payload.wage,
                    spotWorkId: res.spotWorkId,
                    roleId: payload.roleId,
                    status: 0,
                };
                state.shifts[sId] = spotShift;
            });
        }
        catch (err) {
            throw new Error(`Failed to create shift. Error: ${err}`);
        }
        finally {
            state.mutating = false;
        }
    }
    async function updateShift(id, payload) {
        if (state.mutating) {
            return;
        }
        try {
            state.mutating = true;
            const shift = await api.editSpotShift(id, payload);
            state.shifts[shift.id] = shift;
            return shift;
        }
        catch (err) {
            throw new Error(`Failed to update shift. Error: ${err}`);
        }
        finally {
            state.mutating = false;
        }
    }
    async function deleteShift(id) {
        if (state.mutating) {
            return;
        }
        try {
            state.mutating = true;
            await api.deleteSpotShift(id);
            delete state.shifts[id];
        }
        catch (err) {
            throw new Error(`Failed to delete shift. Error: ${err}`);
        }
        finally {
            state.mutating = false;
        }
    }
    function getShift(id) {
        return state.shifts[id];
    }
    function resetPagination() {
        state.pagination.cursor = "";
        state.pagination.done = false;
    }
    function clear() {
        state.shifts = {};
        state.params = {};
        resetPagination();
        state.fetching = false;
        state.mutating = false;
    }
    return {
        state,
        fetchNextPage,
        refresh,
        setParams,
        createShift,
        updateShift,
        deleteShift,
        getShift,
        resetPagination,
        clear,
    };
}
